import React from "react";
export const CustomBullet = () => (
  <button type="button" aria-label="slider_dot" />
);
